import Phaser from 'phaser';
import { CONFIG } from '../config.js';

export class Bullet extends Phaser.Physics.Arcade.Sprite {
  constructor(scene, x, y) {
    super(scene, x, y, 'bullet');
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.body.setCircle(5);
    this.damage = 0;
    this.isCrit = false;
  }

  fire(targetX, targetY, damage, isCrit = false) {
    this.damage = damage;
    this.isCrit = isCrit;
    this.setTexture(isCrit ? 'bullet-crit' : 'bullet');
    const r = isCrit ? 7 : 5;
    this.body.setCircle(r);
    const angle = Math.atan2(targetY - this.y, targetX - this.x);
    this.body.setVelocity(
      Math.cos(angle) * CONFIG.PLAYER_BULLET_SPEED,
      Math.sin(angle) * CONFIG.PLAYER_BULLET_SPEED
    );
    this.setRotation(angle);
    this.setScale(isCrit ? 1.4 : 1);

    // Trail
    const trail = this.scene.add.particles(this.x, this.y, isCrit ? 'spark' : 'particle', {
      speed: 30,
      lifespan: 220,
      scale: { start: 0.9, end: 0 },
      alpha: { start: 0.8, end: 0 },
      tint: isCrit ? 0xfde047 : 0xfbbf24,
      follow: this,
      quantity: 1,
      frequency: 18,
    });
    this.trail = trail;

    this.scene.time.delayedCall(2000, () => {
      if (this.active) this.destroy();
    });
  }

  destroy(fromScene) {
    if (this.trail) this.trail.destroy();
    super.destroy(fromScene);
  }
}
